import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/pages',
    name: 'index',
    component: () => import('../views/index.vue'),
    children: [
      {
        path: '/pages/subscribe/pay',
        name: 'pay',
        component: () => import('../views/pay.vue')
      },
      {
        path: '/pages/subscribe/invoice',
        name: 'invoice',
        component: () => import('../views/invoice.vue')
      },
      {
        path: '/pages/subscribe/mode',
        name: 'mode',
        component: () => import('../views/mode.vue')
      },
      {
        path: '/pages/subscribe/subscribe',
        name: 'subscribe',
        component: () => import('../views/subscribe.vue')
      },
      {
        path: '/pages/subscribe/subscribe-multi',
        name: 'subscribe-multi',
        component: () => import('../views/subscribe-multi.vue')
      },
      {
        path: 'order-list',
        name: 'order-list',
        component: () => import('../views/order-list.vue')
      },
      {
        path: 'logistics-info',
        name: 'logistics-info',
        component: () => import('../views/logistics-info.vue')
      },
      {
        path: 'order-info',
        name: 'order-info',
        component: () => import('../views/order-info.vue')
      },
      {
        path: 'personal',
        name: 'personal',
        component: () => import('../views/personal.vue')
      },
      {
        path: 'faqlist',
        name: 'faqlist',
        component: () => import('../views/faqlist.vue')
      },
      {
        path: 'help',
        name: 'help',
        component: () => import('../views/help.vue')
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import('../views/faq.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/pay/b2b',
    name: 'b2b',
    component: () => import('../views/b2b.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
